const colorsPreset = {
  // Content colors
  "--content-base": "#FFFFFF",
  "--content-soft": "#A8A29E",
  "--content-disabled": "#78716C",
  // Informative colors
  "--informative-base": "#23B4C9",
  "--informative-50": "#ECFEFF",
  "--informative-100": "#CFFAFE",
  "--informative-200": "#A5F3FC",
  "--informative-300": "#67E8F9",
  "--informative-400": "#22D3EE",
  "--informative-500": "#06B6D4",
  "--informative-600": "#0891B2",
  "--informative-700": "#0E7490",
  "--informative-800": "#155E75",
  "--informative-900": "#164E63",
  "--informative-950": "#083344",
  // Warning colors
  "--warning-base": "#D67D39",
  "--warning-soft": "#A65028",
  "--warning-soft2": "#E8BC89",
  "--warning-strong": "#E8BC89",
  "--warning-bold": "#F9EDDB",
  "--warning-subtle": "#6C3722",
  "--warning-50": "#FCF7F0",
  "--warning-100": "#F9EDDB",
  "--warning-200": "#F1D7B7",
  "--warning-300": "#E8BC89",
  "--warning-400": "#E09F64",
  "--warning-500": "#D67D39",
  "--warning-600": "#C8672E",
  "--warning-700": "#A65028",
  "--warning-800": "#854027",
  "--warning-900": "#6C3722",
  "--warning-950": "#3A1A10",
  // Error colors
  "--error-base": "#EF4444",
  "--error-soft": "#B91C1C",
  "--error-strong": "#FCA5A5",
  "--error-bold": "#FEE2E2",
  "--error-subtle": "#7F1D1D",
  "--error-50": "#FEF2F2",
  "--error-100": "#FEE2E2",
  "--error-200": "#FECACA",
  "--error-300": "#FCA5A5",
  "--error-400": "#F87171",
  "--error-500": "#EF4444",
  "--error-600": "#DC2626",
  "--error-700": "#B91C1C",
  "--error-800": "#991B1B",
  "--error-900": "#7F1D1D",
  "--error-950": "#450A0A",
  // Success colors
  "--success-base": "#15A462",
  "--success-soft": "#14814F",
  "--success-strong": "#85F0BE",
  "--success-bold": "#DCFCEC",
  "--success-subtle": "#135438",
  "--success-50": "#F0FDF6",
  "--success-100": "#DCFCEC",
  "--success-200": "#BAF8DA",
  "--success-300": "#85F0BE",
  "--success-400": "#49DF99",
  "--success-500": "#21C97B",
  "--success-600": "#15A462",
  "--success-700": "#14814F",
  "--success-800": "#156642",
  "--success-900": "#135438",
  "--success-950": "#052E1D",
  // Dark Brand colors
  "--darkBrand-50": "#FAFAF9",
  "--darkBrand-100": "#F5F5F4",
  "--darkBrand-200": "#E7E5E4",
  "--darkBrand-300": "#D6D3D1",
  "--darkBrand-400": "#A8A29E",
  "--darkBrand-500": "#78716C",
  "--darkBrand-600": "#57534E",
  "--darkBrand-700": "#44403C",
  "--darkBrand-800": "#292524",
  "--darkBrand-900": "#1C1917",
  "--darkBrand-950": "#0C0A09",
  // Accent Brand colors
  "--accentBrand-50": "#FEF1F7",
  "--accentBrand-100": "#FEE5F1",
  "--accentBrand-200": "#FFCBE4",
  "--accentBrand-300": "#FFA1CE",
  "--accentBrand-400": "#FF67AA",
  "--accentBrand-500": "#F92B81",
  "--accentBrand-600": "#EA1865",
  "--accentBrand-700": "#CC0A4C",
  "--accentBrand-800": "#A80C3F",
  "--accentBrand-900": "#8C0F37",
  "--accentBrand-950": "#56011D",
  // Brand colors
  "--brand-50": "#FCF3FA",
  "--brand-100": "#F9EAF6",
  "--brand-200": "#F5D5EE",
  "--brand-300": "#EEB3E1",
  "--brand-400": "#EEB3E1",
  "--brand-500": "#E383CB",
  "--brand-600": "#C33F99",
  "--brand-700": "#B03083",
  "--brand-800": "#8B2967",
  "--brand-900": "#752658",
  "--brand-950": "#461132",
  // Stroke colors
  "--stroke-base": "#44403C",
  "--stroke-soft": "#292524",
  "--stroke-strong": "#57534E",
  "--stroke-error": "#EF4444",
  // Common Alpha colors
  "--commonAlpha-base": "#FFFFFF66",
  "--commonAlpha-soft": "#FFFFFF1A",
  "--commonAlpha-softer": "#FFFFFF0A",
  "--commonAlpha-inverseBase": "#00000066",
  "--commonAlpha-inverseStrong": "#00000099",
  // Refer Balls colors
  "--referBalls-basket1BgStart": "#FBBF24",
  "--referBalls-basket1BgStop": "#FBBF24",
  "--referBalls-basket1Label": "#FBBF24",
  "--referBalls-basket2BgStart": "#E09F64",
  "--referBalls-basket2BgStop": "#E09F64",
  "--referBalls-basket2Label": "#E09F64",
  "--referBalls-basket3BgStart": "#8A32EB",
  "--referBalls-basket3BgStop": "#8A32EB",
  "--referBalls-basket3Label": "#BA83FD",
  "--referBalls-basket4BgStart": "#00BCFF",
  "--referBalls-basket4BgStop": "#00BCFF",
  "--referBalls-basket4Label": "#00BCFF",
  "--referBalls-basket5BgStart": "#59549F",
  "--referBalls-basket5BgStop": "#59549F",
  "--referBalls-basket5Label": "#B8AEDA",
  "--referBalls-basketNormalBgStart": "#45408D",
  "--referBalls-basketNormalBgStop": "#45408D",
  "--referBalls-basketNormalLabel": "#8E89D1",
  // Background Images
  "--bg-header": "radial-gradient(133.74% 100.44% at 100% 50%, #292524 0%, #1C1917 100%)",
  "--bg-dialog": "radial-gradient(69.19% 53.57% at 50% 0%, #44403C 0%, #1C1917 100%)",
  "--bg-homeBtn": "linear-gradient(180deg, #44403C 0%, #292524 50.48%, #44403C 100%)",
  "--bg-grdPrimary": "radial-gradient(50% 100% at 50% 0%, #F92B81 0%, #CC0A4C 100%)",
  "--bg-grdPrimaryAlt": "linear-gradient(180deg, #8C0F37 0%, #A80C3F 100%)",
  "--bg-grdSecondary": "linear-gradient(180deg, #44403C 0%, #292524 100%)",
  "--bg-grdSecondaryAlt": "linear-gradient(180deg, #312D6F 0%, #45408D 100%)",
  "--bg-bottomMenu": "radial-gradient(33.48% 103.75% at 52.2% 0%, #752658 0%, #1C1917 100%)",
  "--bg-bottomNavBtnRound": "linear-gradient(180deg, #FF67AA 0%, #A80C3F 100%)",
  "--bg-bottomNavBtnRoundRimLight": "radial-gradient(50% 25% at 50% 100%, #FDE68A 0%, rgba(86, 1, 29, 0.00) 100%)",
  "--bg-bottomNavBtnIndicatorActive": "radial-gradient(44.58% 50% at 50% 100%, #3c3c3c 0%, #ffffff00 100%)",
  "--bg-bottomNavBtnIndicator": "",
  "--bg-pageTitle": "linear-gradient(180deg, #FFF 19.11%, #D6D3D1 71.43%)",
  "--bg-gradientTextBase": "linear-gradient(180deg, #FFF 19.11%, #D6D3D1 71.43%)",
  "--bg-tabNavSecondary": "linear-gradient(180deg, #44403C 0%, #292524 100%)",
  "--bg-referFriendTopSection": "radial-gradient(73.33% 38.02% at 73.33% 58.07%, #9e9da236 0%, rgba(0, 0, 0, 0.00) 100%)",
  "--bg-progressBarTray": "linear-gradient(180deg, #1C1917 0%, #292524 100%)",
  "--bg-timerProgressBar": "linear-gradient(90deg, #CC0A4C 0%, #B03083 70%, #F92B81 100%)",
  "--bg-timerProgressStripes": "linear-gradient(-45deg,rgba(255,255,255,.20) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.20) 50%,rgba(255,255,255,.20) 75%,transparent 75%,transparent)",
  "--bg-card": "radial-gradient(46.81% 58.96% at 50% 0%, #45408D 0%, #151240 100%)",
  "--bg-flipClock": "linear-gradient(180deg, #57534E 0%, #44403C 42%, #292524 46.5%, #1C1917 100%)",
  "--bg-grdHigh": "radial-gradient(71.88% 55.56% at 50% 0%, theme('backgroundColor.gradientTopHigh') 0%, theme('backgroundColor.gradientBottomHigh') 100%)",
  "--bg-grdMid": "radial-gradient(69.19% 53.57% at 50% 0%, theme('backgroundColor.gradientTopMid') 0%, theme('backgroundColor.gradientBottomMid') 100%)",
  "--bg-grdLow": "radial-gradient(69.19% 53.57% at 50% 0%, theme('backgroundColor.gradientTopLow') 0%, theme('backgroundColor.gradientBottomLow') 100%)",
  // Background Colors
  "--bg-backdrop": "#0C0A09D9",
  "--bg-overlay": "#000000CC",
  "--bg-solidLow": "#1C1917",
  "--bg-gradientTopLow": "#44403C",
  "--bg-gradientBottomLow": "#0C0A09",
  "--bg-solidMid": "#292524",
  "--bg-gradientTopMid": "#44403C",
  "--bg-gradientBottomMid": "#1C1917",
  "--bg-solidHigh": "#44403C",
  "--bg-gradientTopHigh": "#44403C",
  "--bg-gradientBottomHigh": "#292524"
};
const themePinkPulse = {
  id: "pink-pulse",
  name: "Pink Pulse",
  className: "pink-pulse",
  colors: colorsPreset
};
export {
  colorsPreset,
  themePinkPulse
};
